import React   from "react";
import { Table }                  from "react-bootstrap";

function PrescriptionTable({medicines, getTotal, medicineLabel, erx}) {
  const prescribedByDoctor = erx ? erx?.is_prescribed_by_doctor : true;

  function getTotalInfo(med){
    let unit_price = '0.00';
    let total = '0.00';
    if(prescribedByDoctor){
      unit_price = med?.unit_price ? parseFloat(med?.unit_price).toFixed(2) : '0.00';
      total = (med.quantity*med.unit_price).toFixed(2) || '0.00';
    }
    return {
      quantity: med?.quantity || 0,
      unit_price: unit_price,
      total: total
    };
  }

  return (
    <Table className="medicines-confirmed-list">
        <thead>
        <tr className="modal-section-header px-4 py-3 my-6">
            <th>Medicine Name</th>
            <th>Quantity</th>
            <th className="text-nowrap">Unit Price</th>
            <th className="text-right">Total</th>
        </tr>
        </thead>
        <tbody>
          {medicines?.map((med, index) => {
            let info = getTotalInfo(med);
            return (<tr key={`confirm-med-${index}`}>
            <td>
                {medicineLabel(med)}
            </td>
            <td className="text-center">{info.quantity}</td>
            <td className="text-center">{info.unit_price}</td>
            <td className="text-right text-nowrap">RM {info.total}</td>
            </tr>)
          })}
            <tr>
            <td colSpan="3" className="text-right">Grand Total</td>
            <td className="text-right text-nowrap">RM {prescribedByDoctor ? getTotal(medicines) : '0.00'}</td>
            </tr>
        </tbody>
    </Table>
  );
}

export default PrescriptionTable;
